import { memo, useMemo } from "react";
import { useAuditLogsQuery } from "@/modules/auditLogs/hooks/useAuditLogsQuery";
import { Module, PATH_AUDIT_LOGS } from "@/constants";
import { toCamelCase } from "@/lib/utils";
import { useAuditLogsBreadcrumb } from "@/modules/auditLogs/hooks/useAuditLogsBreadcrumb";
import PageHeader from "@/components/PageHeader";
import { DataTableQueryContextProvider } from "@/components/data-table/DataTableQueryContext";
import { List } from "@/components/list/List";
import { readAuditLogTable } from "@/schemas/auditLog";
import { ReadAuditLog } from "@/types/auditLog";
import { AuditLogsDirectoryContent } from "@/modules/auditLogs/components/AuditLogsDirectoryContent";
import { useAuditLogsColumnOverrides } from "@/modules/auditLogs/hooks/useAuditLogsColumnOverrides";

const AuditsDirectoryComponent = () => {
  const { query, options } = useAuditLogsQuery();
  const name = toCamelCase(Module.AuditLogs);
  const breadcrumbItems = useAuditLogsBreadcrumb();
  const columnOverrides = useAuditLogsColumnOverrides();

  const tableFeatures = useMemo(
    () => ({
      enableFilters: true,
      enableSorting: true,
    }),
    [],
  );

  const queryValue = useMemo(() => ({ query }), [query]);

  return (
    <>
      <PageHeader breadcrumbItems={breadcrumbItems} />
      <List<ReadAuditLog>
        schema={readAuditLogTable}
        name={name}
        query={query}
        options={options}
        tableFeatures={tableFeatures}
        columnOverrides={columnOverrides}
        pathBuilder={(row) => `${PATH_AUDIT_LOGS}/${row.id}`}
      >
        <DataTableQueryContextProvider value={queryValue}>
          <div className="flex flex-row gap-2 justify-between items-center py-2">
            <List.Menubar className="mb-0 grow">
              <List.Menubar.Columns />
              <List.Menubar.Reset />
            </List.Menubar>
          </div>
          <AuditLogsDirectoryContent />
        </DataTableQueryContextProvider>
      </List>
    </>
  );
};

export const AuditLogsDirectory = memo(AuditsDirectoryComponent);
